import cartSdk, { CartClient } from '@ordermentum/cart-javascript-sdk';
import { CART_URL } from '@ordermentum/ui-constants';

export default class Cart {
  private static instance: CartClient;

  static token: string;

  static init(token: string, logger?: any) {
    Cart.token = token;
    Cart.instance = cartSdk({
      apiBase: CART_URL,
      token,
      logger,
    });
  }

  static getInstance(logger?: any): CartClient {
    if (!Cart.token) {
      throw new Error('Cart client initialization failed, token not found');
    }
    if (!Cart.instance) {
      Cart.instance = cartSdk({
        apiBase: CART_URL,
        token: Cart.token,
        logger,
      });
    }
    return Cart.instance;
  }
}
